export default [
  {
    // P1 匹配記錄列表頁（含 P2 詳情抽屜 / P3 編輯表單）
    path: '/dashboard/pos-id/film-circuit-ids',
    name: 'pos-id-film-circuit-ids',
    component: () => import('@/views/posId/FilmCircuitIdPage.vue')
  },
  {
    // P4 白名單頁（馬拉松 / 電影節 / 雙場特典）
    path: '/dashboard/pos-id/special-ids',
    name: 'pos-id-special-ids',
    component: () => import('@/views/posId/FilmCircuitSpecialIdPage.vue')
  },
  {
    // P5 變更記錄頁（含 CSV 匯出）
    path: '/dashboard/pos-id/audits',
    name: 'pos-id-audits',
    component: () => import('@/views/posId/PosIdAuditPage.vue')
  },
  {
    // P6 重定向映射頁（只讀 + 刪除，無新增 / 編輯）
    path: '/dashboard/pos-id/manual-fix-mappings',
    name: 'pos-id-manual-fix-mappings',
    component: () => import('@/views/posId/ManualFixMappingPage.vue')
  }
]
